import React, { useState } from 'react'
import { NavBar } from '../../components/NavBar';
import { Footer } from '../../components/Footer';
import "./Menu.css"
import Foodcard from '../../components/foodcard';
import { useEffect } from 'react';
import { fetchProducts, fetchProductsTypes } from '../../statemanagement/actions/products'; // Added fetchProductsTypes
import {useSelector,useDispatch} from 'react-redux';
import LoadingModal from '../../components/LoadingModal';
import { useLocation, useNavigate } from 'react-router-dom';
import { Col, Modal } from 'react-bootstrap';
import { AddToCart, getTotal } from '../../statemanagement/actions/cart';
import { Cart } from '../../components/Cart';
import logo from '../../assets/logo.png';
const MenuType = () => {

    const dispatch = useDispatch();
    const { products, loading, productTypes, loadingProductTypes } = useSelector(state => state.ProductsReducer);
    const navigate = useNavigate();
    const {state} = useLocation();
    const [currentProducts,setCurrentProducts] = useState([])
    const [selectedItem,setSelectedItem] = useState({});
    const [show,setShow] = useState(false);
    const [showCart,setShowCart] = useState(false)
    const [selectedAddOns, setSelectedAddOns] = useState([]);

    useEffect(() => {
        if (state === null) {
            navigate('/menu'); 
            return;
        }
        dispatch(fetchProducts());
        dispatch(fetchProductsTypes()); 
    }, [state, navigate, dispatch]);
    
    useEffect(() => {
        if (!loading && products.length > 0 && state?.type) {
            // Find products where the product's type ID or Name matches the current stat
            const filtered = products.filter(product => {
                // If your dynamic types use IDs, compare IDs. 
                // If they use names, normalize both and compare.
                return normalizeTurkishCharacters(product.product_type.name) === normalizeTurkishCharacters(state.type);
            });
            setCurrentProducts(filtered);
        }
    }, [loading, products, state]);

    function normalizeTurkishCharacters(text) {
        return text
            .replace(/ı/g, "i")
            .replace(/İ/g, "I")
            .replace(/ş/g, "s")
            .replace(/Ş/g, "S")
            .replace(/ç/g, "c")
            .replace(/Ç/g, "C")
            .replace(/ğ/g, "g")
            .replace(/Ğ/g, "G")
            .replace(/ü/g, "u")
            .replace(/Ü/g, "U")
            .replace(/ö/g, "o")
            .replace(/Ö/g, "O")
            .toUpperCase(); // Make sure it's in uppercase for consistent comparisons
    }


    const handleAddOnChange = (addOn) => {
      // If the add-on is already in the array, remove it; otherwise, add it
      if (selectedAddOns.includes(addOn)) {
        setSelectedAddOns(selectedAddOns.filter((item) => item !== addOn));
      } else {
        setSelectedAddOns([...selectedAddOns, addOn]);
      }
    };
  
    const handleAddToCart = () => {
      // Create a cart item that includes the main item + selected add-ons
      const cartItem = {
        ...selectedItem,
        selectedAddOns, // store your add-on array
      };
  
      dispatch(AddToCart(cartItem));
      dispatch(getTotal())
      setShow(false);
    };

    const getOptimizedUrl = (url, width = 800) => {
        if (!url || !url.includes('cloudinary.com')) return url;    
        return url.replace('/upload/', `/upload/f_auto,q_auto,w_${width}/`);
    };

    return (
        <div>
            { !loadingProductTypes && productTypes?.length > 0 && !loading && currentProducts?.length > 0 && 
            <>
            <div className='sticky'>
                <NavBar/>
                <div className="scrollmenu">
                    {/* 4. Map through dynamic productTypes instead of static array */}
                    {productTypes && productTypes.map((item, index) => (
                        <a
                            key={index}
                            onClick={() => {
                                // item.name represents the category name from your API
                                navigate(`/menu/${item.name}`, { state: { type: item.name } })
                            }}
                        >
                            {item.name}
                        </a>
                    ))}
                </div>
            </div>


            {/* MENU DISPLAY ITEMS */}
            <div className='container-fluid menu-row '> 
                <div className='row m-auto'>
                    <div id='menu' className='menu-col mt-3' >
                        <div className='heading-container'>
                            <svg onClick={()=> navigate('/menu')} xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-arrow-left backButton" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"/>
                            </svg>    
                            <h1 className='pt-3 heading'>
                                {state.type}
                            </h1>                    
                        </div>
                        <div className='row'>
                        {currentProducts.map((item) => (
                            <Foodcard onClick={()=>{setShow(true); setSelectedItem(item)}} item={item}></Foodcard>
                        ))}
                        </div>
                    </div>
                </div>
            </div>
            
            <Footer/>
            </>
            }
            <LoadingModal visible={loading || loadingProductTypes || currentProducts.length == 0 || productTypes.length == 0} />
            <Modal
            size='lg'
            show={show}
            onHide={()=>setShow(false)} 
                       
            >
            <Modal.Header closeButton>
                <Modal.Title className='p-2 modal-food-title '>{selectedItem.name}</Modal.Title>
            </Modal.Header>

            
            <Modal.Body className="px-4 pb-4"> 
                <div className='row'>
                    {/* Image Section */}
                    <div className='col-12 text-center mb-3'>
                        <img className="w-50 modal-food-image"  src={selectedItem.image !== null ? getOptimizedUrl(selectedItem.image, 600) : logo} alt={selectedItem.name}/>
                    </div>

                    {/* Description Section with better padding/font */}
                    <div className='col-12 mb-4 px-3'>
                        <h4 className='modal-food-description'>{selectedItem.description}</h4>
                    </div>

                    {/* Add-ons Section */}
                    {selectedItem.additionalProducts && selectedItem.additionalProducts.length > 0 && (
                        <div className='col-12 mb-4 px-3'>
                            <h6 className="fw-bold mb-3" style={{ color: '#222D42' }}>
                                Ürün opsiyonları <span className="text-muted fw-normal">(Zorunlu değil)</span>:
                            </h6>
                            <div className="addon-container p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                {selectedItem.additionalProducts.map((addOn, idx) => (
                                    <div className='form-check d-flex justify-content-between align-items-center mb-2' key={idx}>
                                        <div>
                                            <input
                                                className='form-check-input'
                                                type='checkbox'
                                                id={`flexCheckDefault-${idx}`}
                                                checked={selectedAddOns.includes(addOn)}
                                                onChange={() => handleAddOnChange(addOn)}
                                            />
                                            <label className='form-check-label ms-2' htmlFor={`flexCheckDefault-${idx}`}>
                                                {addOn.name}
                                            </label>
                                        </div>
                                        {Number(addOn.price) !== 0 && (
                                            <span className="small text-muted">+{addOn.price} TL</span>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Action Button: Getir Style */}
                    <div className='col-12 d-flex justify-content-center mt-2'>
                        <button onClick={handleAddToCart} className='btn-getir-style'>
                            <span className="btn-text">Sepete Ekle</span>
                            <span className="btn-price">
                                {(
                                    Number(selectedItem.price || 0) + 
                                    selectedAddOns.reduce((acc, curr) => acc + Number(curr.price || 0), 0)
                                ).toFixed(2)} TL
                            </span>
                        </button>
                    </div>
                </div>
            </Modal.Body>

            </Modal>
            <a id="back-to-top" onClick={()=>{setShowCart(true)}} className="btn login btn-lg back-to-top" role="button"><i className="fas fa-cart-plus fa-xs  "></i></a>
            <Modal size='lg'
                show={showCart}
                onHide={()=>{setShowCart(false)}}
            >
                <div className='row'>
                    <Col id='cart' lg={12}>
                        <Cart/>
                    </Col>
                </div>
            </Modal>
        </div>
    )
}
export default MenuType;